import React from 'react';
import { IonIcon, IonLabel, IonGrid, IonRow, IonCol, IonButton } from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import { RouteComponentProps } from 'react-router-dom';
import { getActivityType, capitalize } from '../services/utils';
import { isPlatform } from '@ionic/react';

import './HeaderActivity.css';
interface HeaderActivityProps extends RouteComponentProps {
  type: string;
  activityTypeId: string;
  isExternal: string;
}

const HeaderActivity: React.FC<HeaderActivityProps> = ({ match, history, location, type, activityTypeId, isExternal }) => {
  let activityType = capitalize(type) + ' ' + getActivityType(Number(activityTypeId));
  let activityColorClass = isPlatform('ios') ? "my_toolbar_ios_" + activityTypeId.toString() : "my_toolbar_" + activityTypeId.toString();
  
  const goBack = () => {
    if (isExternal === "1")
      history.push('/home');
    else
      history.goBack();
  }

  return (
    <IonGrid className={activityColorClass}>
          <IonRow>
            <IonCol size="1" className="ion-align-self-left">
                <IonButton mode="ios" size="small" fill="clear" className="my-back-button" color="primary-contrast" 
                          onClick = {goBack}>
                  <IonIcon mode="ios" icon={chevronBackOutline} color="primary-contrast"/>
                </IonButton>
            </IonCol>
            <IonCol size="5" className="ion-align-self-center"> 
              <IonLabel mode="ios" className="my-label-title">{activityType}</IonLabel>
            </IonCol>
            <IonCol size="6"></IonCol>
          </IonRow>      
    </IonGrid>
  );
};

export default HeaderActivity;
